import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import UploadedImageComponent from './uploaded-image-component'

export interface UploadedImageOptions {
  HTMLAttributes: Record<string, any>,
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    uploadedImage: {
      setUploadedImage: (options: { imageId: string, sessionId: string, alt?: string }) => ReturnType,
    }
  }
}

export const UploadedImage = Node.create<UploadedImageOptions>({
  name: 'uploadedImage',
  
  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  group: 'block',
  
  addAttributes() {
    return {
      imageId: {
        default: null,
        parseHTML: element => element.getAttribute('data-image-id'),
        renderHTML: attributes => ({
          'data-image-id': attributes.imageId,
        }),
      },
      sessionId: {
        default: null,
        parseHTML: element => element.getAttribute('data-session-id'),
        renderHTML: attributes => ({
          'data-session-id': attributes.sessionId,
        }),
      },
      alt: {
        default: null,
        parseHTML: element => element.getAttribute('alt'),
        renderHTML: attributes => attributes.alt ? { alt: attributes.alt } : {},
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="uploaded-image"]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes({ 'data-type': 'uploaded-image' }, HTMLAttributes)]
  },

  addNodeView() {
    return ReactNodeViewRenderer(UploadedImageComponent)
  },

  addCommands() {
    return {
      setUploadedImage: options => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: options,
        })
      },
    }
  },
})